'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var isObject = require('lodash/isObject.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var isObject__default = /*#__PURE__*/_interopDefaultLegacy(isObject);

/**
 * Default implementation of {@link NormalizeCustomType} to normalize custom types to `AssetLike` objects.
 * This is used if no custom implementation is provided.
 * @see {@link InputFile}'s {@link NormalizeCustomType} for more information.
 */
function normalizeCustomType(custom) {
  /*
   * Note: By default, `AssetLike` is the custom type so no conversion
   * needs to happen.
   */
  return custom;
}

/**
 * Default implementation of the type guard {@link IsCustomType}.
 * This is used if no custom implementation is provided.
 * @see {@link InputFile}'s {@link IsCustomType} for more information.
 */
function isCustomType(object) {
  return isObject__default["default"](object) && 'filename' in object;
}

/**
 * Check if a file is a native file.
 * @param file File to check
 */
var isNativeFile = function isNativeFile(object) {
  return object instanceof File;
};
exports.isCustomType = isCustomType;
exports.isNativeFile = isNativeFile;
exports.normalizeCustomType = normalizeCustomType;